import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ShoppingService} from '@app/shopping/shopping.service';
import {ShoppingRoutingModule} from '@app/shopping/shopping-routing.module';
import {ShoppingPromotionsComponent} from '../shopping-promotions/shopping-promotions.component';
import {ShoppingCuponsComponent} from '@app/shopping-cupons/shopping-cupons.component';
import {ShoppingLateralMenuComponent} from '@app/shopping-lateral-menu/shopping-lateral-menu.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ShoppingScratchesComponent} from '@app/shopping-scratches/shopping-scratches.component';
import {NgxMaskModule} from 'ngx-mask';
import {UtilityService} from '../core/utils.service';
import {AuthenticationService} from '@app/core/authentication/authentication.service';
import {QRCodeModule} from 'angularx-qrcode';
import {SearchPipe} from '@app/core/pipe/search.pipe';
import {ChainService} from '@app/chain/chain.service';
import {ShoppingVouchersComponent} from '@app/shopping-vouchers/shopping-vouchers.component';
import {NgxPrintModule} from 'ngx-print';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    CoreModule,
    SharedModule,
    ShoppingRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxMaskModule.forRoot(),
    QRCodeModule,
    NgxPrintModule
  ],
  declarations: [
    ShoppingPromotionsComponent,
    ShoppingCuponsComponent,
    ShoppingScratchesComponent,
    ShoppingVouchersComponent,
    ShoppingLateralMenuComponent,
    SearchPipe
  ],
  providers: [
    AuthenticationService,
    ShoppingService,
    ChainService,
    UtilityService
  ]

})
export class ShoppingModule { }



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shopping/shopping.module.ts